module.exports = __webpack_public_path__ + "img/vertical_7_3_7005.a5d56ca1.png";